export default "__VITE_ASSET__B1SIuQl1__"